/**
 * @generated SignedSource<<bc441414d1f248634dec187dbf96c2ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime'
import { FragmentRefs } from 'relay-runtime'
export type Post_post$data = {
  readonly slug: string
  readonly h1: string
  readonly content_text: string
  readonly template_name: string
  readonly image: {
    readonly url: string
    readonly alt: string | null
  } | null
  readonly modified_at: string
  readonly shortcodes: ReadonlyArray<{
    readonly index: number
    readonly category: string
    readonly code: string
    readonly params: ReadonlyArray<{
      readonly key: string
      readonly value: string | null
    }>
  }>
  readonly ' $fragmentType': 'Post_post'
}
export type Post_post$key = {
  readonly ' $data'?: Post_post$data
  readonly ' $fragmentSpreads': FragmentRefs<'Post_post'>
}

const node: ReaderFragment = {
  argumentDefinitions: [],
  kind: 'Fragment',
  metadata: null,
  name: 'Post_post',
  selections: [
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'slug',
      storageKey: null
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'h1',
      storageKey: null
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'content_text',
      storageKey: null
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'template_name',
      storageKey: null
    },
    {
      alias: null,
      args: null,
      concreteType: 'PostImage',
      kind: 'LinkedField',
      name: 'image',
      plural: false,
      selections: [
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'url',
          storageKey: null
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'alt',
          storageKey: null
        }
      ],
      storageKey: null
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'modified_at',
      storageKey: null
    },
    {
      alias: null,
      args: null,
      concreteType: 'PostShortCode',
      kind: 'LinkedField',
      name: 'shortcodes',
      plural: true,
      selections: [
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'index',
          storageKey: null
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'category',
          storageKey: null
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'code',
          storageKey: null
        },
        {
          alias: null,
          args: null,
          concreteType: 'PostShortCodeParam',
          kind: 'LinkedField',
          name: 'params',
          plural: true,
          selections: [
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'key',
              storageKey: null
            },
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'value',
              storageKey: null
            }
          ],
          storageKey: null
        }
      ],
      storageKey: null
    }
  ],
  type: 'Post',
  abstractKey: null
}

;(node as any).hash = '44344a4bfe85cc30f84a83a89059c08d'

export default node
